import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.scheduleUpdate = this.scheduleUpdate.bind(this)
    this.visualViewport = window.visualViewport

    this.update()
    this.scheduleUpdate()
    this.timeoutId = setTimeout(this.update, 250)

    window.addEventListener("resize", this.scheduleUpdate)
    window.addEventListener("orientationchange", this.scheduleUpdate)
    this.visualViewport?.addEventListener("resize", this.scheduleUpdate)
    this.visualViewport?.addEventListener("scroll", this.scheduleUpdate)
  }

  disconnect() {
    window.removeEventListener("resize", this.scheduleUpdate)
    window.removeEventListener("orientationchange", this.scheduleUpdate)
    this.visualViewport?.removeEventListener("resize", this.scheduleUpdate)
    this.visualViewport?.removeEventListener("scroll", this.scheduleUpdate)

    if (this.frameId) cancelAnimationFrame(this.frameId)
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  scheduleUpdate() {
    if (this.frameId) cancelAnimationFrame(this.frameId)
    this.frameId = requestAnimationFrame(this.update)
  }

  update() {
    this.frameId = null

    const viewportHeight = this.visualViewport?.height || window.innerHeight
    document.documentElement.style.setProperty("--viewport-height", `${viewportHeight}px`)
  }
}
